export default __webpack_public_path__ + "static/media/Sennheiser.05a8f85a.svg";